import RoomType from '../../../../../pm/common/extensions/RoomType';

/**
 * * Модель содержащая информацию о комнате
 */
export default class RoomInfoRequest  {
	/**
	 * * Название комнаты
	 */
	Name!: string;
	/**
	 * * Тип комнаты
	 */
	Type!: RoomType;
	constructor(obj?: Partial<RoomInfoRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
